// extracted by mini-css-extract-plugin
export default {"p_content":"c6fc372a98"};